import { __awaiter, __generator } from "tslib";
import { forEachBatch } from '@office-start/batch-utility';
import { sendTransactionalMessage } from '@office-start/message-listener';
import { IDLE_VERYLOW_PRIORITY, scheduleWork, } from '@office-start/scheduler-service';
function addItemsToTrie(worker, itemsWithIndices, onIndexChanged) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, sendTransactionalMessage({
                        type: "add-trie-items" /* HarmonyItemTrieMessageType.AddTrieItems */,
                        payload: {
                            trieItems: itemsWithIndices.trieItems,
                            trieIndices: itemsWithIndices.trieIndices,
                        },
                    }, worker)];
                case 1:
                    _a.sent();
                    if (onIndexChanged) {
                        onIndexChanged();
                    }
                    return [2 /*return*/];
            }
        });
    });
}
function getHarmonyItemTrieItem(item) {
    var ownerName = item.owner.hasOwner ? item.owner.name : undefined;
    var recentActivities = item.type === 'File' && item.recentActivities.isRecentActivities
        ? item.recentActivities.recentActivities
        : undefined;
    return {
        ownerName: ownerName,
        title: item.title,
        sharedByUsername: item.sharingInfo.sharedByUsername,
        recentActivities: recentActivities,
    };
}
export function addToTrie(worker, indexedItemIdSet, items, onIndexChanged) {
    return __awaiter(this, void 0, void 0, function () {
        var itemsWithIndex;
        return __generator(this, function (_a) {
            itemsWithIndex = items
                .map(function (item, index) { return ({
                item: item,
                index: index,
            }); })
                // Filtering should be done after above map() to ensure index does not get changed
                .filter(function (itemWithIndex) { return !indexedItemIdSet.has(itemWithIndex.item.id); });
            forEachBatch(itemsWithIndex, 10, function (batchedItems) {
                var completed = false;
                scheduleWork(function () {
                    if (completed) {
                        return;
                    }
                    addItemsToTrie(worker, {
                        trieItems: batchedItems.map(function (itemWithIndex) {
                            return getHarmonyItemTrieItem(itemWithIndex.item);
                        }),
                        trieIndices: batchedItems.map(function (itemWithIndex) { return itemWithIndex.index; }),
                    }, onIndexChanged);
                    completed = true;
                }, IDLE_VERYLOW_PRIORITY);
                // TODO: Handle text filter click and rebuild events
                /*this.eventService.events
                    .withScope(ObservableScope.PastAndFuture)
                    .pipe(
                        filter(
                            (event) =>
                                event.name ===
                                AngularEvents.edgeworthTextFilterClicked,
                        ),
                        take(1),
                    )
                    .toPromise()
                    .then(() => {
                        if (completed) {
                            return;
                        }
    
                        setTimeout(() => {
                            if (completed) {
                                return;
                            }
    
                            workHandle.cancelAndRunNow();
                            completed = true;
                        });
                    });
    
                this.eventService.events
                    .withScope(ObservableScope.OnlyFuture)
                    .pipe(
                        filter(
                            (event) =>
                                event.name === AngularEvents.edgeworthRebuildNeeded,
                        ),
                        take(1),
                    )
                    .toPromise()
                    .then(() => {
                        // If a rebuild is needed and we have pending indexing work, we should cancel it because we will be re-building the index anyways.
                        workHandle.cancel();
                    });*/
            });
            return [2 /*return*/, itemsWithIndex.map(function (itemsWithIndex) { return itemsWithIndex.item; })];
        });
    });
}
//# sourceMappingURL=addToTrie.js.map